import Vue from 'vue'
import Vuex, { StoreOptions, ActionContext } from 'vuex'
import auth from './auth'
import dropdown from './dropdown'
import location from './location'
import login from './login'

const store = {
  state: {
    data: [],
  },
  modules: {
    auth,
    dropdown,
    location,
    login
  },
  mutations: {
    setData(state, data) {
      state.data = data;
      localStorage.setItem('rootData', JSON.stringify(state.data));
    },
  },
  actions: {
    //ActionContext 타입이 RootState이므로 위에 있으니 따로 지정안해줘도 됨.
    //기본적으로 RootState에서 관리하기 때문에 각 모듈별로 네임스페이스를 지정해줘야 해당 모듈만 데이터 변화가능.
    setRootData ({commit}, data) {
      commit('setData', data);
    },
  },
  getters: {
    data: (state) => {

      state.data = JSON.parse(localStorage.getItem('rootData') || '[]');

      return state.data;
    }
  },
}
export default new Vuex.Store(store);
